import { useEffect } from "react";
import { Form, FormInstance, Select, Typography } from "antd";
import Arrowdown from "../../../common/images/png/ArrowDown.png";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as ArrowIcon } from "../../../common/images/svg/SuffixSelectIcon.svg";

const { Option } = Select;

interface ISelectBankAccountProps {
  isTablet: boolean;
  form: FormInstance<any>;
  listBankAccountProvider: any[];
  bankAccountSelectedProvider: any;
  setBankAccountSelectedProvider: React.Dispatch<any>;
  paramsBankAccountProvider: {
    start: number;
    end: number;
  };
  setParamsBankAccountProvider: React.Dispatch<
    React.SetStateAction<{
      start: number;
      end: number;
    }>
  >;
  companyDefaultSelected: any;
}

const SelectBankAccountProvider = (props: ISelectBankAccountProps) => {
  const {
    isTablet,
    form,
    listBankAccountProvider,
    bankAccountSelectedProvider,
    setBankAccountSelectedProvider,
    paramsBankAccountProvider,
    setParamsBankAccountProvider,
    companyDefaultSelected,
  } = props;

  // Auto-select if there's only 1 bank account provider
  useEffect(() => {
    if (
      Array.isArray(listBankAccountProvider) &&
      listBankAccountProvider.length === 1
    ) {
      const singleItem = listBankAccountProvider[0];
      setBankAccountSelectedProvider(singleItem);
      form.setFieldsValue({ providerBankAccount: singleItem.id });
    } else {
      setBankAccountSelectedProvider(null);
      form.setFieldsValue({ providerBankAccount: null });
    }
  }, [listBankAccountProvider, companyDefaultSelected]);

  return (
    <div className="director-transfer-bank">
      <Typography style={{ fontSize: 12, color: "white" }}>
        Provider Bank Account
      </Typography>
      <Form.Item
        name={"providerBankAccount"}
        rules={[{ required: true, message: "This field is required" }]}
      >
        <Select
          showSearch
          disabled={!listBankAccountProvider.length}
          popupClassName="select-beneficiary"
          className="select-provider-bank select-recipient"
          suffixIcon={<ArrowIcon />}
          optionLabelProp="label"
          onChange={(id) => {
            const selected = listBankAccountProvider?.find(
              (item: any) => item.id === id
            );
            setBankAccountSelectedProvider(selected);
          }}
          filterOption={(input, option: any) => {
            const bankAccount = listBankAccountProvider.find(
              (w) => w.id === option.value
            );
            return (
              bankAccount?.accountNumber
                ?.toLowerCase()
                .includes(input.toLowerCase()) ||
              bankAccount?.bank?.name?.includes(input.toLowerCase())
            );
          }}
        >
          {Array.isArray(listBankAccountProvider) &&
            listBankAccountProvider.map((item: any) => (
              <Option
                key={item.id}
                value={item.id}
                label={
                  <span className="ant-select-custom-value-sendmoney">
                    {item.accountNumber}
                  </span>
                }
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span className="ant-select-custom-value-sendmoney">
                    {item.accountNumber}
                  </span>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: "12px",
                      }}
                    >
                      {item.bank.name}
                    </span>
                  </div>
                </div>
                {bankAccountSelectedProvider?.id === item.id && (
                  <CheckSelectIcon />
                )}
              </Option>
            ))}
          {listBankAccountProvider.length === paramsBankAccountProvider.end && (
            <Option key="load-more">
              <span
                style={{
                  fontSize: isTablet ? 12 : 14,
                  color: "rgba(29, 171, 241, 1)",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setParamsBankAccountProvider((prev) => ({
                    ...prev,
                    end: prev.end + 10,
                  }));
                }}
              >
                Load more <img src={Arrowdown} />
              </span>
            </Option>
          )}
        </Select>
      </Form.Item>
      {form.getFieldValue("companies_default") ? null : (
        <Typography
          style={{
            fontSize: isTablet ? 10 : 12,
            fontWeight: 400,
            color: "#EC3333",
          }}
        >
          {"Please select a provider before choosing a bank account."}
        </Typography>
      )}
      {bankAccountSelectedProvider ? (
        <>
          <Typography style={{ fontSize: 12, color: "white" }}>
            Currency: {bankAccountSelectedProvider?.currencyCode}
          </Typography>
          <Typography style={{ fontSize: 12, color: "white" }}>
            Account name: {companyDefaultSelected?.name}
          </Typography>
          <Typography style={{ fontSize: 12, color: "white" }}>
            Bank name: {bankAccountSelectedProvider?.bank?.name}
          </Typography>
          <Typography style={{ fontSize: 12, color: "white" }}>
            SWIFT: {bankAccountSelectedProvider?.bank?.swift}
          </Typography>
          <Typography style={{ fontSize: 12, color: "white" }}>
            Bank Address: {bankAccountSelectedProvider?.bank?.legalAddress}
          </Typography>
        </>
      ) : null}
    </div>
  );
};

export default SelectBankAccountProvider;
